<div id="login" fxLayout="column" linPerfectScrollbar>
  @if (isMaintenance) {
  <lin-maintenance [title]="MAINTENANCE_LOGIN_TITLE" [description]="MAINTENANCE_LOGIN_DESCRIPTION" [isFill]="true"></lin-maintenance>
  }
  <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    @if (!isSSOLogin) {
    <div id="login-form">
      <div class="logo">
        <img [src]="(platformSettings$ | async)?.logoUrl" />
      </div>

      <div class="title">{{ 'LOGIN.TITLE_TEXT' | translate | uppercase }}</div>

      @if (formError) {
      <div class="lin-form-error">{{ formError }}</div>
      }

      <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
        <mat-form-field>
          <input matInput autocomplete="username" placeholder="{{ 'FIELDS.EMAIL' | translate }}" formControlName="email" />
          <mat-error>
            <lin-form-field-error [control]="loginForm.get('email')" controlName="email"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input
            matInput
            [type]="showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            placeholder="{{ 'FIELDS.PASSWORD' | translate }}"
            formControlName="password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            [disableRipple]="true"
            (click)="showPassword = !showPassword"
            [attr.aria-label]="(showPassword ? 'FIELDS.HIDE_PASSWORD' : 'FIELDS.SHOW_PASSWORD') | translate"
            data-testid="btn-toggle-password"
          >
            <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error>
            <lin-form-field-error [control]="loginForm.get('password')" controlName="password"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center">
          <mat-checkbox formControlName="isRemeberMe" class="remember-me" aria-label="{{ 'LOGIN.REMEMBER_ME' | translate }}">
            {{ 'LOGIN.REMEMBER_ME' | translate }}
          </mat-checkbox>

          <a class="forgot-password" routerLink="/reset-password"> {{ 'LOGIN.FORGOT_PASSWORD' | translate }}? </a>
        </div>

        <lin-form-submit-button [isLoading]="isSubmitting">
          <span>{{ 'LOGIN.BUTTON_TEXT' | translate }}</span>
        </lin-form-submit-button>
      </form>

      @if ((platformSettings$ | async)?.linkAppStore || (platformSettings$ | async)?.linkPlayMarket) {
      <lin-app-stote-and-google-badges
        [linkAppStore]="(platformSettings$ | async)?.linkAppStore"
        [linkPlayMarket]="(platformSettings$ | async)?.linkPlayMarket"
      ></lin-app-stote-and-google-badges>
      } @if (policyLinks.privacyPolicyLink || policyLinks.termsOfUseLink) {
      <div class="policy-links">
        @if (policyLinks.termsOfUseLink) {
        <span (click)="openLink(policyLinks.termsOfUseLink)">{{ 'NAV.TERMS_OF_USE' | translate }}</span>
        } @if (policyLinks.privacyPolicyLink) {
        <span (click)="openLink(policyLinks.privacyPolicyLink)">{{ 'NAV.PRIVACY_POLICY' | translate }}</span>
        }
      </div>
      }
    </div>
    } @if (isSSOLogin) {
    <mat-spinner strokeWidth="2" diameter="30" color="accent"></mat-spinner>
    }
  </div>
  <div class="login-version">{{ envName }} {{ version }}</div>
</div>
